import React, { FC } from "react";
import Range, { SliderProps as RangeProps } from "rc-slider";
import classNames from "classnames/dedupe";

import { TThemeVariant, useTheme } from "../../Utility/ThemeProvider";

export interface IRangeInputProps extends RangeProps {
  /** Theme */
  variant?: TThemeVariant;
}

/** data of [ value from, value max ] */
export type TRangeTuple = [string, string];

const RangeInput: FC<IRangeInputProps> = ({ variant, ...props }) => {
  const theme = useTheme(variant);

  const rootClasses = classNames({
    "range-slider--light": theme === "light",
  });
  return (
    <Range
      {...props}
      prefixCls="range-slider"
      className={rootClasses}
      allowCross={false}
      range
    />
  );
};

export default RangeInput;
